module.exports = __webpack_public_path__ + "img/21.e66b0683.svg";